import { Link } from "react-router-dom"
import { hero } from "../content/homepage"
import useIsMobile from "../hooks/useIsMobile"

const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
}

export default function Hero() {
    const isMobile = useIsMobile()
    const lines = hero.headline.split("\n")

    return (
        <section style={{ padding: isMobile ? "56px 20px 12px" : "100px 24px 20px", textAlign: "center" }}>
            <h1 style={{
                fontSize: isMobile ? 42 : 84,
                lineHeight: 1.08, margin: 0,
                letterSpacing: "-0.04em", fontWeight: 800,
            }}>
                {lines.map((line, i) => (
                    <span key={i}>{line}{i < lines.length - 1 && <br />}</span>
                ))}
            </h1>

            <p style={{
                maxWidth: 820, margin: isMobile ? "24px auto 32px" : "32px auto 42px",
                fontSize: isMobile ? 18 : 28,
                lineHeight: 1.6, color: "#6B7280",
            }}>
                {hero.subheadline}
            </p>

            <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
                <button onClick={() => scrollTo("section-nav")} style={{
                    background: "#2563EB", color: "white",
                    padding: isMobile ? "14px 24px" : "18px 32px",
                    borderRadius: 14, border: "none", cursor: "pointer",
                    fontWeight: 700, fontSize: isMobile ? 16 : 18,
                    fontFamily: "inherit",
                }}>
                    {hero.primaryCTA.label}
                </button>

                <Link to={hero.secondaryCTA.href} style={{
                    color: "#111827",
                    padding: isMobile ? "14px 24px" : "18px 32px",
                    borderRadius: 14, textDecoration: "none",
                    fontWeight: 700, fontSize: isMobile ? 16 : 18,
                    border: "1px solid #E5E7EB",
                }}>
                    {hero.secondaryCTA.label}
                </Link>
            </div>

            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: isMobile ? 12 : 20, marginTop: 24 }}>
                {[
                    "Questions aligned to current AAPC guidelines",
                    "7-day money-back guarantee",
                    "Free samples — no signup",
                ].map((item) => (
                    <span key={item} style={{ fontSize: 13, color: "#9CA3AF", display: "flex", alignItems: "center", gap: 5 }}>
                        <span style={{ color: "#D1D5DB" }}>·</span> {item}
                    </span>
                ))}
            </div>
        </section>
    )
}
